/* esm.sh - rxjs@7.8.1/dist/esm/internal/util/SequenceError */
import{createErrorClass as o}from"./createErrorClass.mjs";var n=o(r=>function(e){r(this),this.name="SequenceError",this.message=e});export{n as SequenceError};
//# sourceMappingURL=SequenceError.mjs.map